import Reveal from "@/components/base/Reveal";
import { testimonials } from "@/mocks/testimonials";

interface TestimonialsProps {
  badge?: string;
  title?: string;
  description?: string;
}

function initials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export default function Testimonials({
  badge = "Confiança",
  title = "Empresas precisam de tecnologia. Mas também precisam de confiança.",
  description,
}: TestimonialsProps) {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
              <i className="ri-double-quotes-l" aria-hidden="true"></i>
              {badge}
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              {title}
            </h2>
            {description ? (
              <p className="mt-4 text-base leading-relaxed text-foreground-600">{description}</p>
            ) : null}
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item, index) => (
            <Reveal key={item.author} delay={index * 60} className="h-full">
              <figure className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200">
                <div className="flex items-center justify-between">
                  <i className="ri-double-quotes-l text-3xl text-primary-200" aria-hidden="true"></i>
                  <div className="flex items-center gap-0.5 text-accent-500">
                    <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                    <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                    <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                    <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                    <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                  </div>
                </div>

                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-foreground-700">
                  {item.quote}
                </blockquote>

                <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 font-heading text-sm font-bold text-background-50">
                    {initials(item.author)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{item.author}</p>
                    <p className="text-xs text-foreground-500">
                      {item.role} · {item.company}
                    </p>
                    <p className="text-xs text-foreground-400">{item.segment}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}